/**
 * @generated SignedSource<<9618cf0bd101ebd1ddbf31fd966d8b91>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type authenticateWithServerQuery$variables = Record<PropertyKey, never>;
export type authenticateWithServerQuery$data = {
  readonly me: {
    readonly id: string;
  } | null | undefined;
};
export type authenticateWithServerQuery = {
  response: authenticateWithServerQuery$data;
  variables: authenticateWithServerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "authenticateWithServerQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "authenticateWithServerQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "083ab5675215c05da09c7b1b41643484",
    "id": null,
    "metadata": {},
    "name": "authenticateWithServerQuery",
    "operationKind": "query",
    "text": "query authenticateWithServerQuery {\n  me {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "7fa8144b3f07ddd8a8f6d0b2f16c0423";

export default node;
